import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(p) => p.theme.spacing(2)};
  justify-content: space-between;
  max-width: 100%;
  flex: 1 1 auto;
`;

export const LabelsBox = styled(Box)`
  display: flex;
  max-width: 100%;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  gap: 2px;
`;

export const StartBox = styled(Box)`
  display: flex;
  max-width: 100%;
  flex: 1 1 auto;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing(0.5)};
  align-items: center;
`;

export const EndBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
`;
